import { encrypt } from "./crypt";

const addQueryToUrl = function (param, url) {
  // 判断是否有问号
  if (url === undefined) {
    url = "";
  } else if (url.indexOf("?") !== -1) {
    url += "&";
  } else {
    url += "?";
  }
  for (let key in param) {
    if (["", null, undefined].includes(param[key])) continue;
    // 获取 ？ 后的参数，如果有重复的，去除
    let paramsUrl = url
      .split("?")[1]
      ?.split("&")
      .map((item) => item?.split("=")[0])
      .filter((item) => item);
    if (paramsUrl && paramsUrl.indexOf(key) > -1) continue;
    url = url + `${key}=${param[key]}&`;
  }
  return url.slice(0, -1);
};

function isFormData(header) {
  return header["Content-Type"] === "multipart/form-data";
}
function getQueryFromUrl(url) {
  return url
    .replace(/#\/$/, "")
    .replace(/(.*)\?/g, "")
    .split("&")
    .map((item) => item.split("="));
}
/**
 * 1. 全部 url 的 请求参数，改到 body data 中
 */
export function addEncryptUrl(requestArgs) {
  const url = requestArgs.url;
  const data = requestArgs.data;
  const header = requestArgs.header;
  const forceQueryStr = requestArgs.forceQueryStr;
  const enctyptList = [
    process.env.VUE_APP_GPT_DOMAIN,
    process.env.VUE_APP_CHAT_STREAM_URL,
  ];
  const result = enctyptList.find((item) => url?.includes(item));
  // 取出参数数组
  const query = getQueryFromUrl(url);
  // 1.如果不需要加密，直接返回 url 对象
  // 2.如果没有参数
  // 3. 如果是formData类型 'Content-Type': 'multipart/form-data',
  if (!result || query.length === 0 || isFormData(header))
    return {
      url,
      data,
      header,
    };

  // 取出原本的url
  let newUrl = url.replace(/#\/$/, "").replace(/\?(.*)/g, "");
  const urlDataObj = {};
  query.forEach((item) => {
    const [key, value] = item;
    urlDataObj[key] = value;
    if (key === "ekey") {
      newUrl = addQueryToUrl({ ekey: value }, newUrl);
    }
  });

  //额外加的
  if (newUrl.includes("/v2/conversation")) {
    for (const key in data) {
      const value = data[key];
      urlDataObj[key] = value;
    }
  }

  if (Object.entries(urlDataObj).length > 0) {
    newUrl = addQueryToUrl(
      { query_data: encodeURIComponent(encrypt(urlDataObj)) },
      newUrl
    );
  }
  if (forceQueryStr) {
    let forceQueryList = getQueryFromUrl(forceQueryStr);
    const urlForceDataObj = {};
    forceQueryList.forEach((item) => {
      const [key, value] = item;
      urlForceDataObj[key] = value;
    });
    if (Object.entries(urlForceDataObj).length > 0) {
      newUrl = addQueryToUrl(urlForceDataObj, newUrl);
    }
  }
  return {
    url: newUrl,
    data: data
      ? {
          query_data: encrypt(data),
        }
      : data,
    header: {
      ...header,
      "Content-Type": header["Content-Type"]
        ? header["Content-Type"]
        : "application/json",
    },
  };
}
